<template>
  <Head title="Política de Envíos - Realgestion" />
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-darkblue-700 mb-6">Política de Envíos</h1>
    
    <div class="prose max-w-none">
      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">1. Tiempos de Entrega</h2>
      <p class="mb-4">
        Los tiempos de entrega varían según su ubicación. Normalmente, las entregas se realizan en un plazo de 2 a 5 días
        hábiles dentro del área metropolitana.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">2. Costos de Envío</h2>
      <p class="mb-4">
        Los costos de envío se calculan según el peso del producto y la distancia de entrega. Los costos exactos
        se mostrarán durante el proceso de compra.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">3. Seguimiento de Pedidos</h2>
      <p class="mb-4">
        Una vez que su pedido sea enviado, recibirá un número de seguimiento para rastrear su entrega.
      </p>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '@/Layouts/WebLayout.vue'

export default {
  layout: WebLayout,
  components: {
    Head
  }
}
</script> 